import { useEffect, useState, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarMenus from '../components/SidebarMenus';
import api from '../utils/api';
import '../assets/styles/dashboard.css';
import { Tooltip } from 'bootstrap';
import Header from '../components/Header';
const CURRENCY = process.env.REACT_APP_CURRENCY_SYMBOL || '$';

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const agencyData = JSON.parse(localStorage.getItem('agencyData') || '{}');
  const partnerName = agencyData.companyName || 'Partner';
  const partnerEmail = agencyData.email || '';

  const [summaryCards, setSummaryCards] = useState([]);
  const [recentBookings, setRecentBookings] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const LEGEND_COLORS = ['#2563eb', '#16a34a', '#7c3aed', '#ca8a04', '#dc2626', '#0891b2'];


  const initials = partnerName
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }

    const fetchSummaryCards = async () => {
      try {
        const response = await api.post('/api/website/summaryCardsData', {
          agencyId: agencyData._id,
        });
        console.log("response", response);
        if(response.data.status === 1) {
          setSummaryCards(response.data.data);
        } else {
          console.error('Error fetching summary cards:', response.data);
        }
      } catch (error) {
        console.error('Error fetching summary cards:', error);
      }
    };
    const fetchRecentBookings = async () => {
      try {
        const response = await api.post('/api/website/agency-bookings', {
          agencyId: agencyData._id,
          limit: 5,
          offset: 0,
        });
        if(response.data.status === 1) {
          setRecentBookings(response.data.data);
        } else {
          console.error('Error fetching recent bookings:', response.data);
        }
      } catch (error) {
        console.error('Error fetching recent bookings:', error);
      }
    };

    const fetchVehicleTypes = async () => {
      try {
        const response = await api.post('/api/website/get-vehicles-type', {
          agencyId: agencyData._id,
        });
        if (response.data.status === 1) {
          setVehicleTypes(response.data.vehiclesType || []);
        }
      } catch (error) {
        console.error('Error fetching vehicle types:', error);
      }
    };

    fetchSummaryCards();
    fetchRecentBookings();
    fetchVehicleTypes();
  }, [navigate]);

  const totalTrips = vehicleTypes.reduce((sum, v) => sum + (v.tripCounts || 0), 0);
  const donutGradient = (() => {
    if (!totalTrips) {
      return 'conic-gradient(#e5e7eb 0 100%)'; // empty state
    }
    let start = 0;
    const stops = vehicleTypes.map((v, i) => {
      const pct = ((v.tripCounts || 0) / totalTrips) * 100;
      const end = start + pct;
      const color = LEGEND_COLORS[i % LEGEND_COLORS.length];
      const stop = `${color} ${start}% ${end}%`;
      start = end;
      return stop;
    });
    return `conic-gradient(${stops.join(', ')})`;
  })();

  const quickActions = [
    { title: 'New Booking', desc: 'Create a new trip', color: '#2563eb', path: '/create-booking' },
    { title: 'Booking History', desc: 'View all bookings', color: '#7c3aed', path: '/booking-history' },
    { title: 'Commission Report', desc: 'Earnings overview', color: '#16a34a', path: '/commissions' },
    { title: 'Support', desc: 'Get help anytime', color: '#ca8a04', path: '/support' },
  ];

  // const summaryCards = [
  //   { label: "Today's Bookings", value: '14', hint: '+3 vs yesterday', tone: 'up' },
  //   { label: 'Upcoming', value: '6', hint: 'Next 4 hours', tone: 'neutral' },
  //   { label: 'Completed Today', value: '8', hint: '+2 vs yesterday', tone: 'up' },
  //   { label: 'Cancelled Today', value: '1', hint: '-2 vs yesterday', tone: 'down' },
  //   { label: 'Weekly Commission', value: '$329', hint: '+8% vs last wk', tone: 'up' },
  //   { label: 'Monthly Commission', value: '$1,240', hint: '+12% vs last mo', tone: 'up' },
  //   { label: 'Total Earnings', value: '$18,640', hint: 'All time', tone: 'neutral' },
  //   { label: 'Pending Payout', value: '$3,800', hint: 'Est. Jul 15', tone: 'neutral' },
  // ];

  // const recentBookings = [
  //   {
  //     id: 'BK-2847',
  //     customerName: 'James Wilson',
  //     pickup: 'Grand Hyatt NYC',
  //     dropoff: 'JFK Airport T4',
  //     driver: 'Mike R.',
  //     status: 'Completed',
  //     fare: '$68.00',
  //     commission: '$10.20',
  //   },
  //   {
  //     id: 'BK-2846',
  //     customerName: 'Sarah Chen',
  //     pickup: 'Times Square',
  //     dropoff: 'LaGuardia Airport',
  //     driver: 'David K.',
  //     status: 'Ongoing',
  //     fare: '$52.00',
  //     commission: '$7.80',
  //   },
  // ];
  function shortenAddress(address, maxLen = 35) {
    if (!address) return '—';
    const full = address.trim();
    if (full.length <= maxLen) return full;
  
    const firstPart = full.split(',')[0].trim();
    if (firstPart.length <= maxLen) return firstPart;
  
    return `${full.slice(0, maxLen).trim()}…`;
  }
  function AddressLine({ address, className = '' }) {
    const full = address || '—';
    const short = shortenAddress(full);
    const ref = useRef(null);
  
    useEffect(() => {
      if (!ref.current || !address) return;
  
      const tip = Tooltip.getOrCreateInstance(ref.current, {
        title: full,
        placement: 'top',
        trigger: 'hover',
        container: 'body', // important inside tables
      });
  
      return () => tip.dispose();
    }, [address, full]);
  
    return (
      <div
        ref={ref}
        className={`bh-address ${className}`}
        data-bs-toggle="tooltip"
        data-bs-title={full}
      >
        {short}
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <SidebarMenus partnerName={partnerName} partnerEmail={partnerEmail} />

      <main className="dashboard-main">
        <Header title="Dashboard" search={true} bell={true} partnerName={partnerName} initials={initials} searchPlaceholder="Search bookings, customers..." />

        {/* <section className="quick-actions">
          {quickActions.map((a) => (
            <button
              key={a.title}
              type="button"
              className="quick-card"
              onClick={() => navigate(a.path)}
            >
              <span className="quick-icon" style={{ background: a.color }} />
              <div>
                <div className="quick-title">{a.title}</div>
                <div className="quick-desc">{a.desc}</div>
              </div>
            </button>
          ))}
        </section> */}

        <section className="summary-grid">
          {summaryCards.map((c) => (
            <div key={c.label} className="summary-card">
              <div className="summary-label">{c.label}</div>
              <div className="summary-value">{c.value}</div>
              {/* <div className={`summary-hint ${c.tone}`}>{c.hint}</div> */}
            </div>
          ))}
        </section>

        <section className="charts-row">
          <div className="chart-panel">
            <div className="chart-panel-head">
              <h3>Weekly Earnings</h3>
              <strong>$4,950</strong>
            </div>
            <div className="line-chart-placeholder">
              {/* Replace with Chart.js / Recharts when ready */}
              <svg viewBox="0 0 400 160" width="100%" height="160">
                <polyline
                  fill="none"
                  stroke="#2563eb"
                  strokeWidth="3"
                  points="20,120 70,90 120,100 170,60 220,75 270,40 320,55 370,30"
                />
                <polyline
                  fill="rgba(37,99,235,0.12)"
                  stroke="none"
                  points="20,160 20,120 70,90 120,100 170,60 220,75 270,40 320,55 370,30 370,160"
                />
              </svg>
              <div className="chart-days">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((d) => (
                  <span key={d}>{d}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="chart-panel">
            <h3>Vehicle Breakdown</h3>
            <div className="donut-wrap">
            <div
              className="donut"
              style={{ background: donutGradient }}
            />
              <ul className="donut-legend">
              {vehicleTypes.map((v, i) => (
                <li key={v._id}>
                  <span style={{ background: LEGEND_COLORS[i % LEGEND_COLORS.length] }} />
                  {v.vehicleName}
                  {/* trips only if API provides them, e.g. v.trips */}
                  {v.tripCounts != null ? ` — ${v.tripCounts} trips` : ''}
                </li>
              ))}
            </ul>
            </div>
          </div>
        </section>

        <section className="table-panel">
          <div className="table-panel-head">
            <h3>Recent Bookings</h3>
            <button type="button" onClick={() => navigate('/booking-history')}>
              View All →
            </button>
          </div>
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>Booking ID</th>
                  <th>Customer</th>
                  <th>Pickup → Dropoff</th>
                  <th>Driver</th>
                  <th>Date & Time</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Commission</th>
                </tr>
              </thead>
              <tbody>
                {recentBookings.map((b) => (
                  <tr key={b.id}>
                    <td>
                      <button
                        type="button"
                        className="bh-link"
                        onClick={() => navigate(`/booking-details?id=${b._id || b.id}`)}
                      >
                        {b.id}
                      </button>
                    </td>
                    <td>{b.customerName}</td>
                    <td>
                    <AddressLine address={b.pickup ?? b.from_address ?? b.from_location} />
                    <div className="bh-route">
                        <span className="bh-arrow">→</span>{' '}
                        <AddressLine address={b.dropoff ?? b.to_address ?? b.to_location} />
                    </div>
                    </td>
                    <td>{b.driver}</td>
                    <td>
                      <div>{b.date}</div>
                      <div className="bh-muted">{b.time}</div>
                    </td>
                    <td>
                      <span className={`status-pill ${b.status.toLowerCase()}`}>
                        {b.status}
                      </span>
                    </td>
                    <td>{CURRENCY} {b.fare}</td>
                    <td>{CURRENCY} {b.commission}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;